import React, { Component } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  ListGroup,
  ListGroupItem,
  Row,
  TabContent,
  TabPane,
  Spinner,
  Alert
} from "reactstrap";
import ConversationRow from "../Conversations/ConversationsList/ConversationRow";
import ConversationDetails from "../Conversations/ConversationDetails/ConversationDetails";
import UserInfo from "./UserInfo";
import UserIdSearch from "./UserIdSearch";
import { connect } from 'react-redux';
import IntentSelector from "../Intents/IntentSelector";
import "./UserActivity.scss";

const moment = require("moment-timezone");
const apiCalls = require("../../ApiCalls");

class UserActivity extends Component {
  constructor(props) {
    super(props);

    this.selectConversation = this.selectConversation.bind(this);
    this.dropDownToggle = this.dropDownToggle.bind(this);
    this.sortBy = this.sortBy.bind(this);
    this.handleApply = this.handleApply.bind(this);
    this.handlePageClick = this.handlePageClick.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.getIntentData = this.getIntentData.bind(this);
    this.sortByField = "startTime";
    this.sortIsAscending = false;
    this.getConversationsByUserId = this.getConversationsByUserId.bind(this);
    //this.onDismiss1 = this.onDismiss1.bind(this);
    this.onDismiss2 = this.onDismiss2.bind(this);
    this.purgeHistory = this.purgeHistory.bind(this);
    this.deleteUser = this.deleteUser.bind(this);
    this.onDismissAlert1 = this.onDismissAlert1.bind(this);
    this.onDismissAlert2 = this.onDismissAlert2.bind(this);
    this.displayMetadata = this.displayMetadata.bind(this);
    this.receiveMetadataIDP = this.receiveMetadataIDP.bind(this)
    this.scroll = this.scroll.bind(this)
    this.updateGUID = this.updateGUID.bind(this)
    this.setSearchFilter = this.setSearchFilter.bind(this)
    this.getTrainingPhrases = this.getTrainingPhrases.bind(this)
    this.setUserInfoLoading = this.setUserInfoLoading.bind(this)
    this.setUserConversationsLoading = this.setUserConversationsLoading.bind(this)
    this.getTags = this.getTags.bind(this);
    this.state=this.props.state
    this.state.idp = this.props.location.state //set idp user when routing
  }

  componentDidMount() {
    //this.getConversations(null, this.state.startDate.valueOf(), this.state.endDate.valueOf(), this.sortByField, this.sortIsAscending, this.state.offSet);
    this.props.saveState(this.props.location.pathname, this.state)
    if(!this.state.metadata || !this.state.idp)
    {

      this.getChannels();
      this.getTags();
    }
    this.receiveMetadataIDP();
    this.getIntentData()
    this.getTrainingPhrases()

    let promptScroll = document.getElementById("conversation-list-tab")
    if(promptScroll)
    {
    promptScroll.scrollTop = this.state.promptScrollConversations //set a scroll location
    promptScroll.onscroll = this.scroll
    }

    let promptScrollMetadata = document.getElementById("user-info-tab")
    if(promptScrollMetadata)
    {
    promptScrollMetadata.scrollTop = this.state.promptScrollMetadata //set scroll location
    promptScrollMetadata.onscroll = this.scroll
    }

    let promptScrollConversation = document.getElementById("details")
    if(promptScrollConversation)
    {
      promptScrollConversation.scrollTop = this.state.promptScrollConversationDetails //set scroll location
      promptScrollConversation.onscroll = this.scroll
    }
  }

  componentWillUnmount(){
    let promptScroll = document.getElementById("conversation-list-tab")
    if(promptScroll)
    {
      this.setState({promptScrollConversations: promptScroll.scrollTop})
    }

    let promptScrollMetadata = document.getElementById("user-info-tab")
    if(promptScrollMetadata)
    {
      this.setState({promptScrollMetadata: promptScrollMetadata.scrollTop})
    }

    let promptScrollConversation = document.getElementById("details")
    if(promptScrollConversation)
    {
      this.setState({promptScrollConversationDetails: promptScrollConversation.scrollTop})
    }
    this.props.saveState(this.props.location.pathname, this.state)
  }

componentDidUpdate(prevProps, prevState) {
  if (this.props.selectedTrainingDataVersionId !== prevProps.selectedTrainingDataVersionId) {
    this.receiveMetadataIDP();
    this.getIntentData()
    this.getTrainingPhrases()
  }
}

  setSearchFilter(filterVal){
    this.setState({
      searchFilter: filterVal
    })
  }

  updateGUID(guid)
  {
    this.setState({
      guid: guid
    })
  }

  setUserInfoLoading(userInfoLoading){
    this.setState({userInfoLoading: userInfoLoading});
  }

  setUserConversationsLoading(userConversationsLoading){
    this.setState({userConversationsLoading: userConversationsLoading});
  }

  scroll()
  {
    let promptScroll = document.getElementById("conversation-list-tab")
    if(promptScroll.scrollTop){
      this.setState({promptScrollConversations: promptScroll.scrollTop})
    }
    let promptScrollMetadata = document.getElementById("user-info-tab")
    if(promptScrollMetadata) {
      this.setState({promptScrollMetadata: promptScrollMetadata.scrollTop})
    }

    let promptScrollConversationDetails = document.getElementById("details")
    if(promptScrollConversationDetails) {
      this.setState({promptScrollConversationDetails: promptScrollConversationDetails.scrollTop})
    }
  }

  refreshData() {
    if (this.state.selectedConversation) {
      this.getMessagesByConversationId(
        this.state.selectedConversation.conversationId, this.state.selectedConversation.startTime
      );
    }
    this.getTags();
    this.getIntentData()
    this.getTrainingPhrases()
  }

  getIntentData() {
    if (this.props.selectedTrainingDataVersionId >= 0) {
      return apiCalls.getVersionIntents(this.props.selectedTrainingDataVersionId)
        .then(res => {
          if (res) {
            this.setState({ intentData: res.intents })
          }
        })
        .catch(err => {
          this.props.handleAPIError(err);
        })
    }
  }

  getTrainingPhrases(){
    if (this.props.selectedTrainingDataVersionId >= 0) {
      return apiCalls.getTrainingPhrasesByVersionId(this.props.selectedTrainingDataVersionId)
      .then(res =>{
        if(res){
          this.setState({trainingPhraseData: res.trainingPhrases})
        }
      })
      .catch(err => {
        this.props.handleAPIError(err);
      })
    }
  }

  getChannels() {
    return apiCalls.getChannels().then(
      result => {
        if (result && result.channels && result.channels.length > 0) {
            result.channels = [
              { channelName: "All Channels", channelId: null }
            ].concat(result.channels);
          }
          this.setState({
            channelsData: result
          });
      })
      .catch(err => {
        this.props.handleAPIError(err);
      })
  }

  getConversations(
    channelId,
    startTime,
    endTime,
    sortBy,
    sortIsAscending,
    offSet
  ) {
    return apiCalls
      .getConversations(
        channelId,
        startTime,
        endTime,
        sortBy,
        sortIsAscending,
        offSet,
        this.state.perPage,
        this.state.errorFilter,
        this.state.errorCompareOp,
        this.state.errorThreshold,
        this.state.stepsFilter,
        this.state.stepsCompareOp,
        this.state.stepsThreshold,
        this.state.ratingFilter,
        this.state.ratingCompareOp,
        this.state.ratingThreshold,
        this.state.searchFilter,
        this.state.searchValue,
        this.state.intentFilter,
        this.state.intentValue
      )
      .then(
        result => {
          if (result){
            if(
              result.conversations &&
              result.conversations.length > 0
            ) {
              this.setState(() => ({
                conversationsData: result,
                pageCount: Math.ceil(
                  result.conversations[0].totalCount / this.state.perPage
                )
              }));
            }
            else {
                this.setState({
                  conversationsData: [],
                  pageCount: 0
                });
            }
          }
          else{
            this.props.handleAPIError(result);
          }
        },
        error => {
          console.log(error);
        }
      );
  }

  getMessagesByConversationId(conversationId, startTime) {
    return apiCalls.getMessagesByConversationId(conversationId, startTime).then(
      result => {
        if (result) {
          this.setState({
            messagesData: result.messages
          });
        }
      })
      .catch(err => {
        this.props.handleAPIError(err);
      })
  }

  selectConversation(conversation) {
    if (conversation) {
      if (this.state.selectedConversation !== conversation.conversationId) {
        this.setState(
          {
            selectedConversationId: conversation.conversationId,
            selectedConversation: conversation
          },
          () => {
            if (
              this.getSelectedConversationChannelName(
                conversation.channelId
              ).includes("OMNI_VOICE")
            ) {
              this.detailsRef.refs.audio.pause();
              this.detailsRef.refs.audio.load();
            }
          }
        );
        this.getMessagesByConversationId(conversation.conversationId, conversation.startTime);
      }
    } else {
      this.setState({
        selectedConversationId: null,
        selectedConversation: null,
        messagesData: null
      });
    }
  }

  dropDownToggle() {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  }

  getSelectedConversationChannelName() {
    if (
      this.state.channelsData &&
      this.state.channelsData.channels &&
      this.state.channelsData.channels.length > 0 &&
      this.state.selectedConversation
    ) {
      var matchingChannel = this.state.channelsData.channels.filter(
        channel =>
          channel.channelId === this.state.selectedConversation.channelId
      );
      if (matchingChannel.length > 0) {
        return matchingChannel[0].channelName;
      } else {
        return "";
      }
    }
  }

  getConversationsRows() {
    if(this.state.userConversationsLoading) {
      return (
        <div className="loadingSpinner">
          <Spinner color="info" />
        </div>
      )
    }
    else if (this.state.conversationsData && this.state.conversationsData.length > 0)
    {
      return this.state.conversationsData.map((conversation, index) => {
        let foundChannel = this.state.channelsData.channels.find(channel => channel.channelId === conversation.channelId) || {};
        return (
          <ConversationRow
            key={conversation.conversationId}
            settings={this.props.settings}
            conversation={conversation}
            isActive={this.state.selectedConversationId === conversation.conversationId}
            rowNum={this.state.offSet + index + 1}
            selectConversation={this.selectConversation}
            channelName = { foundChannel.channelName }
            formatCount={this.props.formatCount}
            />
        );
      });
    }
  }

  handleApply(picker) {
    this.setState(
      {
        startDate: moment(picker.startDate),
        endDate: moment(picker.endDate),
        currentPage: 0,
        offSet: 0
      },
      () => {
        this.refreshData();
      }
    );
  }

  handlePageClick(page) {
    let offSet = Math.ceil(page.selected * this.state.perPage),
      startTime = this.state.startDate.valueOf(),
      endTime = this.state.endDate.valueOf();

    if (this.state.selectedChannel > 0) {
      this.getConversations(
        this.state.channelsData.channels[this.state.selectedChannel].channelId,
        startTime,
        endTime,
        this.sortByField,
        this.sortIsAscending,
        offSet
      );
    } else {
      this.getConversations(
        null,
        startTime,
        endTime,
        this.sortByField,
        this.sortIsAscending,
        offSet
      );
    }

    if (this.state.selectedConversation) {
      this.getMessagesByConversationId(
        this.state.selectedConversation.conversationId, this.state.selectConversation.startTime
      );
    }

    this.setState({
      currentPage: page.selected,
      offSet: Math.ceil(page.selected * this.state.perPage)
    });
  }

  sortBy(field) {
    if (field === this.sortByField) {
      this.sortIsAscending = !this.sortIsAscending;
    } else {
      this.sortByField = field;
      this.sortIsAscending = false;
    }

    this.setState(
      {
        currentPage: 0,
        offSet: 0
      },
      () => {
        var sortOrder = this.sortIsAscending ? "ASC" : "DESC"
        return apiCalls.getConversationByUserId(this.state.userId, this.sortByField, sortOrder)
        .then(
          result => {
            if (result &&
              result.conversations &&
              result.conversations.length > 0
              ) {
                this.setState(() => ({
                  conversationsData: result.conversations,
                  pageCount: Math.ceil(
                    result.conversations[0].totalCount / this.state.perPage
                  )
                }));
              } else {
                this.setState({
                  conversationsData: [],
                  pageCount: 0
                });
              }
          })
          .catch(err => {
            this.props.handleAPIError(err);
          })
      }
    );
  }

  getSortIcon(field) {
    if (field === this.sortByField) {
      if (this.sortIsAscending) {
        return <i className="fa fa-angle-up ml-1" />;
      } else {
        return <i className="fa fa-angle-down ml-1" />;
      }
    } else {
      return null;
    }
  }

  getTags() {
    return apiCalls.getTags().then(
      result => {
        if (result) {
          var tags = [];
          if (result.tags && result.tags.length > 0) {
            for (var x = 0; x < result.tags.length; x++) {
              tags.push({TagId: result.tags[x].TagId, TagName: result.tags[x].TagName});
            }
          }
          this.setState({
            tags: tags
          });
        }
      })
      .catch(err => {
        this.props.handleAPIError(err);
      })
  }

  getConversationsByUserId(result) {
    //if(this.state.visible1) this.onDismiss1();
    if(this.state.visible2) this.onDismiss2();
    if(this.state.alert1) this.onDismissAlert1();
    if(this.state.alert2) this.onDismissAlert2();
    this.setState({canDeleteUser: false});
    var conversations = result.conversations.conversations;
    if (result.conversations.guid === 2) {
      this.setState({
        visible2: true
      })
    }
    else{
      this.setState({
        canPurge: true
      })
    }

    if (conversations && conversations.length > 0) {
      this.setState({
        conversationsData: conversations,
        //userId: result.userId,
        selectedConversation: null,
        messagesData: null,
      });
    } else {
      this.setState({
        conversationsData: null,
        userId: null,
        messagesData: null,
        selectedConversation: null,
        //visible1: true
      });
    }

    if(this.state.idp)
    {
      this.setState({
        userId: this.state.idp.name,
        idp: undefined
      })
    }
  }

  onDismiss2() {
    this.setState({ visible2: false });
  }

  onDismissAlert1() {
    this.setState({ alert1: false });
  }

  onDismissAlert2() {
    this.setState({ alert2: false });
  }

  purgeHistory() {
    if (this.state && this.state.guid !== null) {
      apiCalls.purgeUserHistory(this.state.guid).then(result => {
        if (result)
          if(JSON.stringify(result).substring("true")){
          this.setState({ alert2: true });
          }
      })
      .catch(err => {
        this.props.handleAPIError(err);
      })
      //TODO: actual UPM profile deletion check
      this.setState({
        alert2: true,
        conversationsData: null,
        messagesData: null,
        selectedConversation: null,
        canDeleteUser: true,
        canPurge: false
      });
    }
  }

  deleteUser() {
    if (this.state && this.state.userId !== null) {
      apiCalls.deleteUserByGUID(this.state.guid)
        .then(result => {
          if (result) {
            if (JSON.stringify(result) == "true") {
              //TODO: why is result undefined
            }
          }
        })
        .catch(err => {
          this.props.handleAPIError(err);
        })
      }
      this.setState({
        alert1: true,
        conversationsData: null,
        messagesData: null,
        selectedConversation: null,
        userId: null,
        canDeleteUser: false
      });
  }

  displayMetadata(metadataObj, userName, taskObj)
  {

    if(metadataObj)
    {
      this.setState({
        metadata: metadataObj,
        userId: userName,
        taskData: taskObj,
        intentsLoading: true
      })
      let queryParams = {
        guid: this.state.guid,
        startTime: metadataObj.FirstEngagement.firstTimestamp,
        endTime: metadataObj.LastEngagementDetails.lastTimestamp,
      }
      apiCalls.getUserIntents(queryParams).then(res =>{
        if(res){
          this.setState({
            userIntents: res.results.recordset,
            intentsLoading: false
          })
        }
      })
      .catch(err => {
        this.props.handleAPIError(err);
        this.setState({intentsLoading: false});
      })
    }
  }

  receiveMetadataIDP(){
    if(this.state.idp)
    {
      let guid = this.state.idp.guid
      let name = this.state.idp.name

      this.updateGUID(guid)

      apiCalls.getMetadata(guid).then(metadataRes => {
        if(metadataRes){

          apiCalls.getLastTask(guid).then((taskRes)=>{
            if(taskRes){

              this.displayMetadata(metadataRes, name, taskRes)
            }
          })
        }

          //this.displayMetadata(result, name)
        })
        .then(()=>{
          apiCalls.getConversationsByGUID(guid)
            .then(result => {
              if(result){
                var obj = {
                    conversations: result,
                    userId: name,
                }
                this.getConversationsByUserId(obj);
              }
            })
        })
        .catch(err => {
          this.props.handleAPIError(err);
        })
    }
  }

  render() {
    return (
      <div className="animated fadeIn full-height">
        <Card className="pageCard page-card">
          <CardHeader>
            <i className="fa fa-align-justify" />
            <strong>User Profiles</strong>
            <div className="card-header-actions" />
          </CardHeader>
          <CardBody className="card-body">
            <Row>
              <Col xs="5" className="full-height">
                <Row className="user-id-search-row">
                  <Col className="full-height">
                    <UserIdSearch
                      {...this.props}
                      getConversationsByUserId={this.getConversationsByUserId}
                      canDeleteUser={this.state.canDeleteUser}
                      deleteUser={this.deleteUser}
                      purgeHistory={this.purgeHistory}
                      displayMetadata={this.displayMetadata}
                      userId={this.state.userId}
                      canPurge={this.state.canPurge}
                      updateGUID={this.updateGUID}
                      setUserInfoLoading={this.setUserInfoLoading}
                      setUserConversationsLoading={this.setUserConversationsLoading}
                      setSearchFilter={this.setSearchFilter}
                    />
                  </Col>
                </Row>
                <Alert
                    color="info"
                    isOpen={this.state.visible2}
                    toggle={this.onDismiss2}
                    size="sm"
                  >
                    No user found.
                  </Alert>
                  <Alert
                    color="secondary"
                    isOpen={this.state.alert1}
                    toggle={this.onDismissAlert1}
                    size="sm"
                  >
                    Sucessfully deleted user.
                  </Alert>
                  <Alert
                    color="secondary"
                    isOpen={this.state.alert2}
                    toggle={this.onDismissAlert2}
                    size="sm"
                  >
                    Sucessfully removed user history.
                  </Alert>

                {this.props.settings.upmProfileInfoToggle &&
                  <Row className="user-info-row">
                  <Col className="full-height">
                    <UserInfo
                      {...this.props}
                      guid={this.state.guid}
                      userId={this.state.userId}
                      intentsLoading={this.state.intentsLoading}
                      userInfoLoading={this.state.userInfoLoading}
                      metadata={this.state.metadata}
                      userIntents={this.state.userIntents}
                      taskData={this.state.taskData}
                      formatCount={this.props.formatCount}
                    />
                  </Col>
                </Row>
                }
              </Col>
                  <Col>
                    <IntentSelector
                      {...this.props}
                    />
                  </Col>
            </Row>
            <Row style={{ height: this.props.settings.upmProfileInfoToggle ? "48%" : "90%" }}>
                  <Col className="full-height">
                    <TabContent className="conversation-list-tab" id='conversation-list-tab'>
                      <TabPane className="full-height">
                        <ListGroup
                          id="conversations-list"
                          role="tablist"
                          className="conversations-list"
                        >
                          <ListGroupItem>
                            <Row className="lgi-row">
                              <Col
                              xs="2"
                              className="index-col"
                              >
                                <span>Index</span>
                                {/* {this.getSortIcon("steps")} */}
                              </Col>
                              <Col
                                xs="3"
                                className="start-time-col"
                                onClick={() => {
                                  this.sortBy("startTime")
                                }}
                              >
                                <span>Start Time</span>
                                {this.getSortIcon("startTime")}
                              </Col>
                              <Col
                                xs="2"
                                className="steps-col"
                                onClick={() => {
                                  this.sortBy("steps");
                                }}
                              >
                                <span>Steps</span>
                                {this.getSortIcon("steps")}
                              </Col>
                              <Col
                                xs="3"
                                className="warnings-col"
                                onClick={() => {
                                  this.sortBy("errors");
                                }}
                              >
                                <span>Warnings</span>
                                {this.getSortIcon("errors")}
                              </Col>
                            </Row>
                          </ListGroupItem>
                          {this.getConversationsRows()}
                        </ListGroup>
                      </TabPane>
                    </TabContent>
                  </Col>
                  <Col xs="7" className="full-height">
                <ConversationDetails
                  {...this.props}
                  addAlertMsg={this.props.addAlertMsg}
                  ref={node => (this.detailsRef = node)}
                  selectedConversation={this.state.selectedConversation}
                  intentData={this.state.intentData}
                  channelName={this.getSelectedConversationChannelName()}
                  messagesData={this.state.messagesData}
                  getTags={this.getTags}
                  tags={this.state.tags}
                  tagMap={this.state.tagMap}
                  key={this.state.selectedConversation}
                  refresh={this.refreshData}
                  trainingPhraseData={this.state.trainingPhraseData}
                />
                </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  settings: state.settings.settings,
  selectedTrainingDataVersionId: state.versions.selectedVersions.training_data_version_id,
  freeze: state.versions.freeze
});

export default connect(mapStateToProps, {})(UserActivity);
